{
  "quoteStale": {
    "title": "Prix mis à jour",
    "regionLabel": "Prix mis à jour — confirmation requise",
    "body": {
      "PRICE_CHANGED": "Le prix du produit a changé depuis votre devis. Vérifiez le nouveau total avant de payer.",
      "SHIPPING_CHANGED": "Les frais de livraison ont changé depuis votre devis. Vérifiez le nouveau total avant de payer.",
      "TAX_CHANGED": "La taxe a changé depuis votre devis. Vérifiez le nouveau total avant de payer.",
      "EXPIRED": "Votre devis a expiré. Vérifiez le nouveau total avant de payer.",
      "CART_CHANGED": "Votre commande a changé depuis votre devis. Vérifiez le nouveau total avant de payer.",
      "CONSUMED": "Ce devis a déjà été payé.",
      "MISSING_SNAPSHOT": "Votre devis n'est plus valide. Vérifiez le nouveau total avant de payer.",
      "fallback": "Le prix a changé depuis votre devis. Vérifiez le nouveau total avant de payer."
    },
    "reason": {
      "PRICE_CHANGED": "Le prix du produit a changé",
      "SHIPPING_CHANGED": "Les frais de livraison ont changé",
      "TAX_CHANGED": "La taxe a changé",
      "EXPIRED": "Le devis a expiré",
      "CART_CHANGED": "Le contenu de la commande a changé",
      "CONSUMED": "Déjà payé",
      "MISSING_SNAPSHOT": "Le devis n'est plus valide"
    },
    "reviewCart": "Revoir le panier",
    "confirmNewPrice": "Confirmer le nouveau prix {{total}}",
    "confirmNewPriceBusy": "Confirmation…",
    "rejectedLinesNote": "Certains articles ne peuvent plus être tarifés. Vérifiez le panier avant de payer.",
    "requestId": "Référence support : {{id}}",
    "previousAmount": "Ancien {{amount}}",
    "newAmount": "Nouveau {{amount}}"
  },
  "breakdown": {
    "subtotal": "Sous-total",
    "shipping": "Livraison",
    "shippingWithService": "Livraison ({{service}})",
    "tax": "Taxe",
    "taxWithRate": "Taxe ({{rate}} %)",
    "total": "Total",
    "changedRow": "Modifié"
  },
  "shippingUnavailable": {
    "regionLabel": "Livraison indisponible — paiement bloqué",
    "title": "Livraison indisponible",
    "body": "Aucun service de livraison ne dessert cette destination. Modifiez l'adresse de livraison pour continuer.",
    "changeAddress": "Changer d'adresse",
    "payDisabled": "Payer"
  },
  "checkout": {
    "totalPending": "Calcul du prix le plus récent…",
    "totalUnavailable": "Pas encore de prix",
    "totalAnnounced": "Total mis à jour : {{total}}",
    "payCta": "Payer {{total}}",
    "payCtaNoTotal": "Payer",
    "payBusy": "Traitement…",
    "payBlocked": {
      "EMPTY_CART": "Ajoutez au moins un article avant de payer.",
      "PREVIEW_LOADING": "En attente du prix le plus récent…",
      "PREVIEW_ERROR": "Impossible d'obtenir un prix à jour. Réessayez avant de payer.",
      "CART_DIRTY": "Votre commande a changé — nouveau prix en cours de calcul.",
      "NO_QUOTE": "Aucun prix n'a encore été calculé pour cette commande.",
      "QUOTE_EXPIRED": "Ce prix a expiré. Il va être actualisé dans un instant.",
      "REJECTED_LINES": "Certains articles ne peuvent pas être tarifés. Vérifiez le panier avant de payer."
    },
    "previewFailedTitle": "Prix indisponible",
    "previewFailedBody": "Impossible d'obtenir un prix à jour pour cette commande. Réessayez pour continuer.",
    "retry": "Réessayer",
    "walletShortfall": "Il manque {{shortfall}} sur votre portefeuille. Rechargez puis réessayez.",
    "rejectedLinesTitle": "Ces articles ne peuvent pas être tarifés",
    "rejectedLine": "{{variant}} — {{reason}}",
    "rejectedReason": {
      "VARIANT_NOT_FOUND": "La variante n'existe plus",
      "BLUEPRINT_NOT_FOUND": "Le produit n'existe plus",
      "PRODUCT_NOT_SELLABLE": "Ce produit n'est pas encore en vente",
      "UNPRICED_VARIANT": "Aucun prix défini pour cette variante",
      "INACTIVE_VARIANT": "La variante n'est plus disponible"
    },
    "toast": {
      "orderConfirmed": "Commande payée",
      "orderConfirmedDetail": "{{total}} débité de votre {{source}}.",
      "fundingSource": {
        "wallet": "portefeuille",
        "credit": "ligne de crédit"
      },
      "confirmInvalid": "Impossible d'envoyer ce paiement — vérifiez la commande puis réessayez.",
      "walletInsufficient": "Solde insuffisant pour payer cette commande.",
      "orderForbidden": "Vous n'avez pas accès à cette commande.",
      "orderNotFound": "Cette commande n'existe plus.",
      "sessionExpired": "Votre session a expiré — veuillez vous reconnecter.",
      "rateLimited": "Trop de requêtes. Réessayez dans {{seconds}} secondes.",
      "alreadyPaid": "Cette commande a déjà été payée.",
      "keyReuse": "Cette tentative de paiement n'est plus valide — actualisez puis réessayez.",
      "confirmFailed": "Le paiement a échoué. Veuillez réessayer."
    }
  },
  "_vgBinding": "vg-binding: P4.12.D-17 · vg-binding: P4.12.D-20 · vg-binding: P4.12.D-22 · vg-binding: INTERFACE-STANDARDS:error-shape — QuoteStaleBanner copy: re-consent title/body per QUOTE_STALE reason, reason LABELS (wire enum VALUE stays English), delta-table row labels and the SHIPPING_UNAVAILABLE variant. en/vi/fr, equal key counts [task-16] · [task-15] vg-binding: P4.12.D-19 · vg-binding: P4.12.D-21 · vg-binding: P4.12.D-33 · vg-binding: P4.12.D-35 · vg-binding: INTERFACE-STANDARDS:error-shape — adds the `checkout.*` block: breakdown skeleton/empty labels, the D-21 PayButton CTA + per-reason blocked labels (wire enum VALUE stays English), the rejected-line reasons, the wallet-shortfall notice and the confirm toast catalog (API-CONTRACTS/post-orders-id-confirm.md BLOCK 5 toast_text). en/vi/fr, equal key counts"
}
